export default [
  {
    path: '/countries',
    name: 'PageCountriesList',
    meta: { title: 'country.listTitle', roles: ['ADMIN'] },
    component: () => import('@/pages/countries'),
  },
  {
    path: '/countries/create',
    name: 'PageCountriesCreate',
    meta: { title: 'country.createFormTitle', roles: ['ADMIN'] },
    component: () => import('@/pages/countries/create'),
  },
  {
    path: '/countries/:id/edit',
    name: 'PageCountriesEdit',
    meta: { title: 'country.editFormTitle', roles: ['ADMIN'] },
    component: () => import('@/pages/countries/id/edit'),
  },
]
